import { Chart } from 'chart.js';
import { useEffect } from 'react';
import { removeChartIndicatorLine, setChartIndicatorLine } from '../../indicatorAnnotations';

export const ChartIndicatorLine = ({
  chart,
  id,
  dataIndex,
  color,
}: {
  chart: Chart;
  /** Unique per chart - a line registered under an existing id replaces it. */
  id: string;
  dataIndex: number;
  color: string;
}) => {
  useEffect(() => {
    setChartIndicatorLine(chart, id, { dataIndex, color });
    return () => removeChartIndicatorLine(chart, id);
  }, [chart, color, dataIndex, id]);

  return null;
};
